<template>
  <div class="documentList-y">
    <div class="documentContent">
      <div class="inner">
        <div class="documentInner">
          <div class="screenTop">
            <p class="title">意见反馈</p>
          </div>
          <div class="documentListContent">
            <p class="txt">感谢您使用 ASSign电子合同系统，为了便于我们向您提供更好的服务，请您提出宝贵的意见！</p>
            <textarea v-model="textEara" placeholder="请输入您的意见和建议"></textarea>
            <div class="button" @click="sub">
              提交
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        textEara:''
      }
    },
    methods: {
      sub(){
        if(this.textEara ==''){
          this.$message({
            message: '请填写您的建议与意见',
            type: 'warning'
          });
        }else {
          let _this = this;
          _this.ajpost('/api/system/addFeedBack',{content:_this.textEara},function (data) {
            if(data.code==0){
              _this.$message({
                message: '提交成功，感谢您的反馈!',
                type: 'success'
              });
              _this.textEara = ''
            }else{
              _this.$message({
                message:data.msg,
                type: 'warning'
              });
            }
          })
        }
      }
    }
  }
</script>
<style>
  @import "../../assets/less/yjfk.css";
</style>



// WEBPACK FOOTER //
// src/components/userCenter/yjfk.vue